

<error-error-content 
  image="assets/img/images/error-images/image1.png"
  errorType="PAGE_NOT_FOUND"
  copy="ERROR_404"></error-error-content>
